import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import API from "../api/axios";
import toast from "react-hot-toast";

export default function SubscriptionVerify() {
  const [searchParams] = useSearchParams();
  const reference = searchParams.get("reference");
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    const verify = async () => {
      if (!reference) {
        navigate("/subscription");
        return;
      }
      try {
        const res = await API.get(`/subscriptions/verify/${reference}`);
        localStorage.setItem("user_plan", `${res.data.plan} plan`);
        setStatus("success");
        toast.success(`${res.data.plan} plan activated successfully`);
        setTimeout(() => navigate("/"), 3000);
      } catch (err) {
        setStatus("failed");
        toast.error("Payment verification failed");
        setTimeout(() => navigate("/subscription"), 3000);
      }
    };
    verify();
  }, [reference, navigate]);

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        {status === "verifying" && (
          <>
            <p style={s.icon}>⏳</p>
            <h2 style={s.title}>Verifying Payment</h2>
            <p style={s.sub}>Please wait while we confirm your payment...</p>
          </>
        )}
        {status === "success" && (
          <>
            <p style={s.icon}>🎉</p>
            <h2 style={s.title}>Payment Successful</h2>
            <p style={s.sub}>Your subscription is now active. Redirecting to dashboard...</p>
          </>
        )}
        {status === "failed" && (
          <>
            <p style={s.icon}>❌</p>
            <h2 style={s.title}>Payment Failed</h2>
            <p style={s.sub}>Something went wrong. Redirecting back to subscription page...</p>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  wrapper: {
    minHeight: "100vh", display: "flex", alignItems: "center",
    justifyContent: "center", background: "#0a0f0f", padding: "20px",
  },
  card: {
    background: "#0f1a1a", border: "1px solid #1e3333", borderRadius: "16px",
    padding: "48px 32px", textAlign: "center", maxWidth: "420px", width: "100%",
  },
  icon: { fontSize: "56px", marginBottom: "16px" },
  title: { fontSize: "24px", fontWeight: "700", color: "#e8f5f5", marginBottom: "12px" },
  sub: { fontSize: "15px", color: "#5a8a8a", lineHeight: "1.6" },
};